export const SITE_TYPES = {
  ONLINE_INVITATION: "online_invitation",
  WEDDING: "wedding",
};

export const VIDEO_LIMIT = 20;
export const PHOTO_LIMIT = 1_000;

export const MAX_DOMAIN_LENGTH = 64;
export const MAX_PASSWORD_LENGTH = 30;

export const GUESTS_TOKEN_EXPIRE_TIME_SECONDS = 60 * 60 * 24 * 3; // 3 Days

export const getSlateDocFromText = (content, textAlignment = "center") => {
  if (typeof content === "string") {
    return [
      {
        align: textAlignment,
        children: [
          {
            text: content,
          },
        ],
        type: "paragraph",
      },
    ];
  }

  return [
    {
      children: content.map((textItem) => ({
        children: [
          {
            text: textItem,
          },
        ],
        type: "list-item",
      })),
      type: "bulleted-list",
    },
  ];
};

export const BLANK_SLATE_DOCUMENT = getSlateDocFromText("");
export const BLANK_SLATE_DOCUMENT_WITH_LEFT_ALIGNMENT = getSlateDocFromText(
  "",
  "left",
);

// A slate document can be empty but not match BLANK_SLATE_DOCUMENT exactly,
// e.g. it could have an empty paragraph with left alignment instead of center.
export const isEmptySlateDocument = (doc) => {
  if (!doc || !Array.isArray(doc) || doc.length === 0) {
    return true;
  }

  if (doc.length === 1) {
    const firstNode = doc[0];

    if (
      firstNode.type === "paragraph" &&
      Array.isArray(firstNode.children) &&
      firstNode.children.length === 1 &&
      !firstNode.children[0].text?.trim()
    ) {
      return true;
    }
  }

  return false;
};

export const PREVIEW_IFRAME_ID = "pagePreviewIframe";

export const DEFAULT_SIDEBAR_WIDTH = "479px";

export const PREFERRED_CONTACT_METHOD = {
  EMAIL: "email",
  PHONE: "phone",
  NONE: "none",
};
